module.exports = __webpack_public_path__ + "4163600873864c6f20e9c369901ab3b8.svg";